import { Col } from 'reactstrap'
import { H3 } from '../../../../AbstractElements'
import { darkBackgroundData } from '../../../../Data/Ui-Kits/HelperClasses/HelperClassesData'
import { DarkBackground } from '../../../../utils/Constant'

const DarkBackgrounds = () => {
  return (
    <Col xl="4" sm="6">
      <div className="border-wrapper h-100 border">
        <H3 className="mb-3">{DarkBackground}</H3>
        <div className="helper-common-box">
          <div className="helper-box bg-primary"></div>.bg-primary
        </div>
        {darkBackgroundData.map((item, index) => (
          <div className="helper-common-box" key={index}>
            <div className={`helper-box bg-${item}`}></div>.bg-{item}
          </div>
        ))}
      </div>
    </Col>
  )
}

export default DarkBackgrounds